import localforage from 'localforage';
import type { RootState } from './reducers';
import { REHYDRATE } from './types.js';
import type { ReduxActionOutcome, ReduxNonApiAction } from './storeTypes';

localforage.config({
    driver: localforage.INDEXEDDB,
    name: 'europa',
    version: 1.0,
    storeName: 'europa_store',
    description: ''
});

const doRehydrate = (payload: Partial<RootState>) =>
    ({
        type: REHYDRATE,
        payload
    }) as const satisfies ReduxNonApiAction;

export const loadPersistedState = (store: Partial<RootState>) => {
    const payload: Partial<RootState> = {};
    localforage
        .iterate((value: Partial<RootState>, key) => {
            payload[key] = value;
        })
        .then(() => {
            store.dispatch(doRehydrate(payload));
        })
        .catch((e) => {
            console.warn('Unable to read state from storage:', e);
        });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const persistState = async (path: string, slice: Partial<RootState>, meta: any) => {
    try {
        await localforage.setItem(path, slice);
    } catch (e) {
        console.error(`Unable to persist state for ${path} to storage:`, e, meta);
    }
};

export const removeState = async (path: string) => {
    try {
        await localforage.removeItem(path);
    } catch (e) {
        console.error('Unable to remove item from storage:', e);
    }
};

export type RehydrateActionOutcome = ReduxActionOutcome<ReturnType<typeof doRehydrate>>;
